import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../state/app.state";
import {CommonService} from "../../../../shared/services/common.service";
import {Subject, takeUntil} from "rxjs";
import {
  roles,
  rolesLabelMap
} from "../../../../shared/constants/common.constants";
import {groupInfo} from "../../core/behavior-tracker.selectors";

@Component({
  selector: 'app-behavior-tracker-summary-screen',
  templateUrl: './summary-screen.component.html',
  styleUrls: ['./summary-screen.component.css']
})
export class BehaviourTrackerSummaryScreenComponent {
  groupInfo: {};
  protected readonly rolesLabelMap = rolesLabelMap;
  protected readonly roles = roles;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private router: Router,
    private store: Store<fromRoot.State>,
    private commonService: CommonService,
    private route: ActivatedRoute
  ) {

  }

  ngOnInit() {
    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        const urlParams = {
          params: this.route.snapshot.params,
          queryParams: this.route.snapshot.queryParams
        }

        const prevUrlParams = this.commonService.urlParams.getValue();

        if (JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
          this.commonService.urlParams.next(urlParams);
        }
      });

    this.store.select(groupInfo)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.groupInfo = data
      })

  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
